import { Button, styled } from '@mui/material';

export const ProjectFormElement = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(3),
  flexGrow: 1,
  width: '100%',
  maxWidth: 1240,
  margin: '0 auto',
  padding: theme.spacing(1, 0, 4),
  background: theme.palette.background.dashboardMainContent,
}));

export const ExperimentFormElement = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(3),
  padding: theme.spacing(1),
}));

export const AddExperimentButton = styled(Button)(({ theme }) => ({
  borderColor: theme.palette.primary.main,
}));
